import { UsageBar } from '../UsageBar/UsageBar';
import { MyPlanSectionCard } from '../MyPlanSectionCard/MyPlanSectionCard';
import styles from './CycleUsageCard.module.css';

interface CycleUsageItem {
	label: string;
	used: number;
	max: number;
	hint?: string;
	variant?: 'token' | 'quota';
}

interface CycleUsageCardProps {
	subtitle: string;
	items: CycleUsageItem[];
}

export const CycleUsageCard = ({ subtitle, items }: CycleUsageCardProps) => {
	return (
		<MyPlanSectionCard title="Consumo do ciclo" subtitle={subtitle}>
			<div className={styles.bars}>
				{items.map((item) => (
					<UsageBar key={item.label} {...item} />
				))}
			</div>
		</MyPlanSectionCard>
	);
};
